export const sizes = {
    mainContainerWidthDesktop: '800px',
    mainContainerWidthTabletLarge: '700px',
    mainContainerWidthTabletSmall: '500px',
    mainContainerWidthPhoneLarge: '360px',
    mainContainerWidthPhoneSmall: '290px'
};
